import { useContext } from 'react';

import MfaContext from '../MfaContext';

/**
 * Returns the app-level MFA challenge runner. Call it to gate an operation
 * behind MFA: it runs the operation, and if the backend replies 428 the shared
 * MfaProvider prompts for a TOTP code and retries with the code in the request body.
 *
 *   const runWithMfa = useMfa();
 *   const response = await runWithMfa(
 *     (mfaCode) => someApi(payload, mfaCode),
 *     { onMfaRequired: () => setIsLoading(false) }
 *   );
 *   // response is the successful/passthrough Response, or null if the user
 *   // cancelled or hit a terminal MFA error.
 *
 * The optional `onMfaRequired` callback fires when a 428 is detected, before
 * the TOTP modal opens — use it to clear button loading states so the spinner
 * doesn't persist behind the modal.
 *
 * Without an MfaProvider (isolated renders / tests) this runs the operation
 * without gating.
 *
 * @returns {(operation: (mfaCode?: string) => Promise<Response>, options?: { onMfaRequired?: Function }) => Promise<Response|null>}
 */
const useMfa = () => useContext(MfaContext);

export default useMfa;
